
import { handleAxiosException } from '@/api'
import { cguApi, CGUDto } from '@/api/cgu'
import { formatDate } from '@/utils/dates'
import Vue from 'vue'
import { marked } from 'marked'

export default Vue.extend({
  components: {

  },
  data() {
    return {
      cgu: undefined as undefined | CGUDto,
    }
  },
  methods: {
    handleAxiosException,
    formatDate,
    async loadData() {
      try {
        this.cgu = await cguApi.fetchCGUMarkdown(Number(this.$route.query.sale))
      } catch (e) {
        this.handleAxiosException(e)
      }
    },
  },
  mounted() {
    this.loadData()
  },
  computed: {
    markdown(): string | Promise<string> {
      return marked(this.cgu?.content ?? '')
    },
  },
  watch: {
    '$i18n.locale': {
      handler(oldV, newV) {
        if (oldV !== newV) {
          this.loadData()
        }
      },
    },
  },
})
